import { createAddressFromString } from '@tevm/utils'

export const parentBeaconBlockRootAddress = createAddressFromString('0x000F3df6D732807Ef1319fB7B8bB8522d0Beac02')
